import React from 'react';
import SearchBar from '../../SearchBar/index.jsx';
import { Helmet } from 'react-helmet';
import BrowseTopDrugs from '../BrowseTopDrugs/index.jsx';
import { withTranslation, useTranslation } from 'react-i18next';
import {
  HOME_CANONICAL,
  BROWSE_PRESC_SUB_DESC_EN
} from '../../../constants/defaults';
import { object } from 'prop-types';
import _ from 'lodash';
import SkipTo from '../../common/Tag/SkipTo';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const BrowsePrescriptionSubLayout = ({
  respData,
  filters,
  location,
  history,
  match
}) => {
  const { searchTerm } = match.params;
  const { t, i18n } = useTranslation();
  const term = (respData && respData.letter) || searchTerm;
  const keys = Object.keys(filters);
  let { extraTerm } = match.params;
  if (extraTerm && extraTerm.includes('-'))
    extraTerm = extraTerm.replace('-', ': ');
  const selectedValue = extraTerm ? extraTerm : searchTerm;
  const toggleSearch = () => {
    const clickEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    });
    const myButton = document.getElementById('mobile-search-icon');
    myButton.dispatchEvent(clickEvent);
  };
  const descDrugs = respData.drugs.map(item => ' ' + item.name).slice(0, 7);
  const descTerms =
    extraTerm && !_.isEmpty(extraTerm)
      ? extraTerm.charAt(0).toUpperCase() + extraTerm.slice(1)
      : term;

  const getHrefLang = (pathname, lang) => {
    let hrefLang = `https://www.singlecare.com/${pathname}`;
    if (match.params.extraTerm) {
      if (match.params.extraTerm.length > 2) {
        return `${hrefLang}/${term.toLowerCase()}/${term.toLowerCase()}-${
          lang === 'en' ? 'other' : 'otro'
        }`;
      } else {
        return `${hrefLang}/${term.toLowerCase()}/${match.params.extraTerm}`;
      }
    } else {
      return `${hrefLang}/${term.toLowerCase()}`;
    }
  };

  const getMetaData = () => {
    return (
      <Helmet>
        <title>{respData && respData.title}</title>
        <meta
          name="description"
          content={`${BROWSE_PRESC_SUB_DESC_EN} ${descTerms}:${descDrugs}.`}
        />
        <link
          rel="canonical"
          href={`https://www.singlecare.com${location.pathname.toLowerCase()}`}
        />
        <link
          rel="alternate"
          href={getHrefLang('browse-prescriptions', 'en')}
          hrefLang="en-us"
        />
        <link
          rel="alternate"
          href={getHrefLang('es/buscar-medicamentos', 'es')}
          hrefLang="es-us"
        />
        <meta property="og:title" content={respData && respData.ogTitle} />
        <meta
          property="og:description"
          content={respData && respData.ogDescription}
        />
        <meta
          property="og:image"
          content={`${HOME_CANONICAL}/content/images/homepage/singleCareLogo.jpg`}
        />
        <meta
          property="og:url"
          content={`https://www.singlecare.com${location.pathname}`}
        />
        <meta property="og:site_name" content="SingleCare" />
        <meta property="og:type" content="website" />
      </Helmet>
    );
  };
  return (
    <div className="homepage homepage-new">
      <div className="mainBrowsePrescriptionsDrugs">
        {getMetaData()}
        <div className="topShadow"></div>
        <section className="mainTopBreadcrumb">
          <ul role="navigation" aria-label="Breadcrumb">
            <li className="breadcrumb-item">
              <a href={_.withLocale(i18n.language, '/browse-prescriptions')}>
                {t('Browse Prescriptions')}
              </a>
            </li>
            <li className="breadcrumb-item">
              {extraTerm && !_.isEmpty(extraTerm) ? (
                <a
                  href={_.withLocale(
                    i18n.language,
                    `/browse-prescriptions/${term.toLowerCase()}`
                  )}
                >
                  {term.toUpperCase()}
                </a>
              ) : (
                <span>{term.toUpperCase()}</span>
              )}
            </li>
            {extraTerm && (
              <li className="breadcrumb-item">
                <span>
                  {extraTerm.charAt(0).toUpperCase() + extraTerm.slice(1)}
                </span>
              </li>
            )}
          </ul>
        </section>
        <section className="alphabetSection">
          <div className="alphabetDrugs">
            <SkipTo>
              <h1 className="marginBottom-10">{respData && respData.h1}</h1>
            </SkipTo>
            <h2 className="drugNote">
              {_.isEmpty(respData && respData.drugs)
                ? `Not having any drugs listed by brand and/or generic name starting with the letter "${
                    selectedValue.length > 1
                      ? selectedValue.charAt(0).toUpperCase() +
                        selectedValue.slice(1)
                      : selectedValue
                  }".`
                : respData && respData.subtext}
            </h2>
            {searchTerm != '0-9' && (
              <div className="midSearchSection">
                <div className="alphabet">
                  {keys.slice(1).map(alphabet => (
                    <a
                      href={
                        filters[alphabet]
                          ? _.withLocale(
                              i18n.language,
                              `/browse-prescriptions/${searchTerm.toLowerCase()}/${alphabet.toLowerCase()}`
                            )
                          : '#'
                      }
                      key={alphabet}
                      className={
                        alphabet.toLowerCase() === selectedValue.toLowerCase()
                          ? 'active'
                          : filters[alphabet]
                          ? ''
                          : 'inactive'
                      }
                    >
                      {alphabet}
                    </a>
                  ))}
                  <a
                    href={_.withLocale(
                      i18n.language,
                      `/browse-prescriptions/${searchTerm.toLowerCase()}/${keys[0]
                        .toLowerCase()
                        .replace(': ', '-')}`
                    )}
                    className={
                      keys[0].toLowerCase() === extraTerm &&
                      extraTerm.toLowerCase()
                        ? 'active'
                        : filters[keys[0]]
                        ? ''
                        : 'inactive'
                    }
                  >
                    {keys[0]}
                  </a>
                </div>
                <div
                  className="masthead--search show-recent"
                  role="search"
                  aria-label="Type your drug name"
                >
                  <div
                    id="desktTopSearchbar"
                    className="browsePrescriptionsSearch desktop-search desktop-only"
                  >
                    <SearchBar
                      classes="search-container"
                      handleZipCodeChange={() => null}
                      history={history}
                      showZipCode={false}
                    />
                  </div>
                  <div className="mobile-search">
                    <button
                      onClick={() => toggleSearch()}
                      className="input-search open-search-mobile mobile-only whiteFocus"
                    >
                      {/*<span className="sc-icon sc-icon-search input-search--icon" />*/}
                      <span className="input-search--placeholder">
                        {t('Type your drug name')}
                      </span>
                    </button>
                    <div className="site-search-form--query mobile-show">
                      <button
                        type="submit"
                        value={t('Search')}
                        className="search-btn sc-outline-btn--cool-gray"
                      >
                        <span className="search-icon">
                          <LazyLoadImage
                            src="/content/images/icons/search-icon.svg"
                            alt=""
                            width="27"
                            height="27"
                          />
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
        {!_.isEmpty(respData && respData.drugs) && (
          <BrowseTopDrugs
            drugs={respData && respData.drugs}
            term={respData && respData.letter}
            heading={respData && respData.h2}
          />
        )}
        <div
          className="browseDrugsLink"
          dangerouslySetInnerHTML={{
            __html: respData && respData.browseAllMedicationsLink
          }}
        ></div>
      </div>
    </div>
  );
};

BrowsePrescriptionSubLayout.propTypes = {
  respData: object,
  filters: object
};

BrowsePrescriptionSubLayout.defaultProps = {
  respData: {},
  filters: {}
};

export default withTranslation()(BrowsePrescriptionSubLayout);
